import React from "react";

export default function ProfitStats({ profits, earnings }) {
  const getValueClass = (value) => {
    if (value > 0) return 'profit-positive';
    if (value < 0) return 'profit-negative';
    return 'profit-neutral';
  };

  const formatMana = (value) => {
    return Math.round(value).toLocaleString();
  };

  const renderRows = (data, isEarnings = false) => (
    <>
      <tr>
        <th>1d</th>
        <td className={getValueClass(isEarnings ? -data['1d'] : data['1d'])}>
          {formatMana(isEarnings ? -data['1d'] : data['1d'])}
        </td>
      </tr>
      <tr>
        <th>1w</th>
        <td className={getValueClass(isEarnings ? -data['1w'] : data['1w'])}>
          {formatMana(isEarnings ? -data['1w'] : data['1w'])}
        </td>
      </tr>
      <tr>
        <th>1m</th>
        <td className={getValueClass(isEarnings ? -data['1m'] : data['1m'])}>
          {formatMana(isEarnings ? -data['1m'] : data['1m'])}
        </td>
      </tr>
      <tr>
        <th>Life</th>
        <td className={getValueClass(isEarnings ? -data.lifetime : data.lifetime)}>
          {formatMana(isEarnings ? -data.lifetime : data.lifetime)}
        </td>
      </tr>
    </>
  );

  return (
    <div className="profit-section">
      <h3>Profit</h3>
      <p className="section-description">All market profits, including unrealized</p>
      <table className="stats-table">
        <tbody>{renderRows(profits, false)}</tbody>
      </table>
      <h3 className="lower-profit-section">Earnings</h3>
      <p className="section-description">Realized profits transferred back to main account</p>
      <table className="stats-table">
        <tbody>{renderRows(earnings, true)}</tbody>
      </table>
    </div>
  );
}
